import { ChildrenProp, ClassNameProp } from '../../common-types';
import { VBox } from '../../layout';
import React from 'react';

/**
 * Properties for a {@link PatientDetailsSection} component.
 * @author agd
 */
type PatientDetailsSectionProps = ChildrenProp &
  ClassNameProp & {
    /** Section title */
    title: string;
  };

/**
 * Component to make styling of the sections of a `PatientDetails` component easier.
 *
 * @param properties a {@link PatientDetailsSectionProps} object
 * @return the created {@link JSX.Element}.
 * @author agd
 * @constructor
 */
export function PatientDetailsSection({
  children,
  title,
  className = ''
}: PatientDetailsSectionProps): JSX.Element {
  return (
    <VBox
      className={`card-layout ehs-patient-details-section ${className}`.trim()}
    >
      <h3 className="section-title">{title}</h3>
      {children}
    </VBox>
  );
}
